module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.29079/images/pngs/Inbound.png"